import { To } from "react-router-dom";
import getPageOffset from "./getPageOffset";

const composePaginationLinkTo = (
    pageNumber: number,
    limit: number,
    searchParams: URLSearchParams
): To => {
    const linkSearchParams = new URLSearchParams(searchParams.toString());
    const offset = getPageOffset(pageNumber, limit);

    linkSearchParams.set("start_rank", String(offset));

    return {
        pathname: ".",
        search: `?${linkSearchParams.toString()}`,
    };
};

export default composePaginationLinkTo;
